<div class="ranking-table-container" (click)="$event.stopPropagation()">

  <!-- ── Sticky top bar: pill toggle + count ─────────────────────────────── -->
  <div class="rd-top-bar" (click)="$event.stopPropagation()">
    <div class="rd-pill-toggle">
      <button
        class="rd-pill-btn"
        type="button"
        [class.rd-pill-btn--active]="activeTab === 'company'"
        [disabled]="!hasBannerData || isLoading"
        (click)="switchTab('company'); $event.stopPropagation()">
        Company
      </button>
      <button
        class="rd-pill-btn"
        type="button"
        [class.rd-pill-btn--active]="activeTab === 'industry'"
        [disabled]="isLoading"
        (click)="switchTab('industry'); $event.stopPropagation()">
        Industry
      </button>
    </div>

    <span class="rd-count-label" *ngIf="!isLoading">
      {{ activeCount }} store{{ activeCount !== 1 ? 's' : '' }}
    </span>
    <span class="rd-count-label" *ngIf="isLoading">Loading…</span>
  </div>

  <!-- ── Column Headers ──────────────────────────────────────────────────── -->
  <div class="col-header-row">
    <div class="col-header rank-col">Rank</div>
    <div class="col-header location-col">Location Name &amp; Address</div>
    <div class="col-header spend-col">{{ salesLabel }}</div>
  </div>

  <!-- ── Rows ────────────────────────────────────────────────────────────── -->
  <div class="table-body">

    <!-- Skeleton rows while loading -->
    <ng-container *ngIf="isLoading">
      <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8]">
        <div class="cell rank-col"><div class="skel skel-rank"></div></div>
        <div class="cell location-col">
          <div class="skel skel-name"></div>
          <div class="skel skel-addr"></div>
        </div>
        <div class="cell spend-col"><div class="skel skel-spend"></div></div>
      </div>
    </ng-container>

    <!-- Data rows -->
    <ng-container *ngIf="!isLoading">
      <div class="data-row"
           *ngFor="let item of activeData"
           [class.data-row--selected]="item.isSelected"
           [class.data-row--clicked]="item.isClickedStore && !item.isSelected">

        <div class="cell rank-col">
          <span class="rank-num"
                [class.rank-num--selected]="item.isSelected"
                [class.rank-num--clicked]="item.isClickedStore && !item.isSelected">{{ item.rank }}</span>
        </div>

        <div class="cell location-col">
          <div class="loc-name">
            {{ item.locationName }}
            <span class="selected-tag" *ngIf="item.isSelected">Selected Store</span>
            <span class="clicked-tag" *ngIf="item.isClickedStore && !item.isSelected">Current Store</span>
          </div>
          <div class="loc-addr">{{ item.address }}</div>
        </div>

        <div class="cell spend-col">
          <span class="spend-val">{{ item.annualSpend }}</span>
        </div>

      </div>

      <div class="rd-empty" *ngIf="activeData.length === 0">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="2" stroke="rgba(255,255,255,0.1)" stroke-width="1.5"/>
          <path d="M9 9h6M9 12h4" stroke="rgba(255,255,255,0.1)" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        No {{ activeTab === 'company' ? 'company' : 'industry' }} ranking data available
      </div>
    </ng-container>

  </div>

</div>
